import axios from "axios"
import API from "./API.jsx"

import mensagemApp from './config/MensagemApp.js'

class ServicoAPI {
	static async qtdServico(dados) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/qtdeServicos`,
			params: {
				idProf: dados.idProf
			},
			method: "GET",
			metodo: "GET",
			cabecalho: {
				"token": dados.token
			}
		}).then(res => res.data).catch(rej => rej)
	}

	static async buscarServicos(dados) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: '/servicoExecucao',
			params: {
				idProf: dados.idProf
			},
			method: 'GET',
			metodo: 'GET',
			cabecalho: {
				token: dados.token
			}
		}).then(res => {
			return res.data
		}).catch(rej => {
			return { codigo: 400, erro: mensagemApp.msgErroApi }
		})
	}

	static async buscarServicosAcertar(dados) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: '/servicoAcertar',
			params: {
				idProf: dados.idProf
			},
			method: 'GET',
			metodo: 'GET',
			cabecalho: {
				token: dados.token
			}
		}).then(res => {
			return res.data
		}).catch(rej => {
			return { codigo: 400, erro: mensagemApp.msgErroApi }
		})
	}

	static async buscarQuantAcertar(dados) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: '/servicoAcertarQuant',
			params: {
				idProf: dados.idProf
			},
			method: 'GET',
			metodo: 'GET',
			cabecalho: {
				token: dados.token
			}
		}).then(res => {
			return res.data
		}).catch(rej => {
			return { codigo: 400, erro: mensagemApp.msgErroApi }
		})
	}

	static async buscarServico(id, dados) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/servicoExecucao?idProf=${dados.idProf}&idServico=${id}`,
			method: 'GET',
			metodo: 'GET',
			cabecalho: {
				token: dados.token
			}
		}).then(res => {
			return res.data
		}).catch(rej => {
			return { codigo: 400, erro: mensagemApp.msgErroApi }
		})
	}

	static async pesquisarServicoExecucao(dados, termo) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/pesquisarServicoExecucao?idProf=${dados.idProf}&termo=${encodeURIComponent(termo)}`,
			method: 'GET',
			metodo: 'GET',
			cabecalho: {
				token: dados.token
			}
		}).then(res => res.data).catch(() => {
			return { codigo: 400, erro: mensagemApp.msgErroApi }
		})
	}

	static async statusFinalizar(dados, idServico, idEndereco, tipoVeiculo, location) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/statusFinalizar?idProf=${dados.idProf}&idServico=${idServico}&idEndereco=${idEndereco}&tipoVeiculo=${tipoVeiculo}&la=${location.latitude}&lo=${location.longitude}`,
			method: 'GET',
			metodo: 'GET',
			cabecalho: {
				token: dados.token
			}
		}).then(res => { return res }).catch(rej => { return rej })
	}

	static async marcarChegada(dados, data, location, origem = '') {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: '/chegueiEndereco',
			method: 'PUT',
			metodo: 'PUT',
			cabecalho: {
				token: dados.token
			},
			data: {
				idProf: dados.idProf,
				idServico: data.idServico,
				idEndereco: data.idEndereco,
				la: location.latitude,
				lo: location.longitude,
				origem: origem
			}
		}).then(res => { return res }).catch(rej => { return rej })
	}

	/**
	 * Resolve qual ponto pertence ao código lido no scanner e valida as regras de
	 * localização já configuradas pelo cliente.
	 *
	 * @param {object} opcoes idServico limita a busca a um serviço; idEndereco confirma
	 *                        o ponto escolhido quando o código casou com mais de um.
	 */
	static async localizarPontoPorCodigo(dados, conteudoScan, location, opcoes = {}) {
		let rota = `/localizarPontoPorCodigo?idProf=${dados.idProf}`
		rota += `&conteudoScan=${encodeURIComponent(conteudoScan)}`
		rota += `&la=${location.latitude}&lo=${location.longitude}`

		if (opcoes.idServico) rota += `&idServico=${opcoes.idServico}`
		if (opcoes.idEndereco) rota += `&idEndereco=${opcoes.idEndereco}`

		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: rota,
			method: 'GET',
			metodo: 'GET',
			cabecalho: {
				token: dados.token
			}
		}).then(res => res.data).catch(() => {
			return { resultado: false, mensagem: mensagemApp.msgErroApi }
		})
	}

	static async finalizarEndereco(dados, data) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/finalizarEndereco`,
			method: 'PUT',
			metodo: 'PUT',
			cabecalho: {
				token: dados.token
			},
			data: {
				idProf: dados.idProf,
				idServico: data.idServico,
				idEndereco: data.idEndereco,
				la: data.la,
				lo: data.lo,
				observacao: data.observacao,
				motivo: data.motivo
			}
		}).then(res => { return res.data }).catch(rej => { return rej })
	}

	static async buscarCotacoes(dados, local) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/cotacoes`,
			method: 'GET',
			metodo: 'GET',
			params: {
				idProf: dados.idProf,
				la: local.latitude,
				lo: local.longitude
			},
			cabecalho: {
				token: dados.token
			}
		}).then(res => { return res.data }).catch(rej => { return rej })
	}

	/** Polyline da rota (OSRM via PHP) para o mapa da cotação. */
	static async calcularRotaCotacao(dados, { pontos, tipoVeiculo = "M" }) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/calcularRotaCotacao`,
			method: "POST",
			metodo: "POST",
			data: {
				idProf: dados.idProf,
				tipoVeiculo,
				pontos: (pontos || []).map((p) => ({
					la: p.la ?? p.latitude,
					lo: p.lo ?? p.longitude,
				})),
			},
			cabecalho: {
				token: dados.token,
			},
			timeout: 15000,
		}).then((res) => res.data).catch((rej) => rej)
	}

	static async responderCotacao(dados, data, local) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/responderCotacao`,
			method: 'PUT',
			metodo: 'PUT',
			data: {
				...data,
				la: local.latitude,
				lo: local.longitude
			},
			cabecalho: {
				token: dados.token
			}
		}).then(res => { return res.data }).catch(rej => { return rej })
	}

	static async responderCotacaoVinculados(dados, data, local) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/aceitarCotacoesVinculadas`,
			method: 'PUT',
			metodo: 'PUT',
			data: {
				...data,
				la: local.latitude,
				lo: local.longitude
			},
			cabecalho: {
				token: dados.token
			}
		}).then(res => { return res.data }).catch(rej => { return rej })
	}

	static async buscarPuxarServicos(dados, local) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/puxarServicos`,
			method: 'GET',
			metodo: 'GET',
			params: {
				idProf: dados.idProf,
				la: local.latitude,
				lo: local.longitude
			},
			cabecalho: {
				token: dados.token
			}
		}).then(res => { return res.data }).catch(rej => { return rej })
	}

	static async responderPuxarServico(dados, idServico) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/puxarServico`,
			method: 'PUT',
			metodo: 'PUT',
			data: {
				idProf: dados.idProf,
				idServico: idServico
			},
			cabecalho: {
				token: dados.token
			}
		}).then(res => { return res.data }).catch(rej => { return rej })
	}

	static async enviarAssinatura(dados, idServico, idEndereco, nome, doc, tipoDoc, imagem) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/salvarDadosFinalizar`,
			method: 'POST',
			metodo: 'POST',
			data: {
				idProf: dados.idProf,
				idServico: idServico,
				idEndereco: idEndereco,
				identificador: 'A',
				nome: nome,
				doc: doc,
				tipo: tipoDoc,
				imagem: imagem
			},
			cabecalho: {
				token: dados.token
			}
		}).then(res => { return res }).catch(rej => { return rej })
	}

	static async validarCPF(dados, doc, tipoDoc) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: `/validarDocs`,
			method: 'POST',
			metodo: 'POST',
			data: {
				tipo: tipoDoc,
				doc: doc,
				idProf: dados.idProf
			},
			cabecalho: {
				token: dados.token
			}
		}).then(res => res.data).catch(rej => rej)
	}

	static async cancelarServico(dados, id, opt, label) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/cancServApp",
			method: "POST",
			metodo: "POST",
			data: {
				idServico: id,
				opCancelamento: opt,
				txtCancelamento: label,
				idProf: dados.idProf
			},
			cabecalho: {
				token: dados.token
			}
		}).then(res => res.data).catch(rej => rej)
	}

	static async buscarConfigTelaCotacao(dados) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/telaCotacoes",
			method: "GET",
			metodo: "GET",
			params: {
				idProf: dados.idProf
			},
			cabecalho: {
				token: dados.token
			}
		}).then(res => res.data).catch(rej => rej)
	}

	static async salvarImagemCDN(dados, img) {

		/**
		 * return await API.post("/appProfissional/acessar", {
					dominio: dados.dominio,
					rota: "/salvarImagemCDN",
					method: "POST",
					metodo: "POST",
					data: {
						idProf: dados.idProf,
						imagem: img,
						timeout: 29500
					},
					cabecalho: {
						token: dados.token
					}
				}).then(res => res.data).catch(rej => rej)
		 */

		return await API.post("/appProfissional/salvarImagemCDN", {
			cabecalho: {
				token: dados.token
			},
			idProf: dados.idProf,
			imagem: img
		}, { timeout: 90000 }).then(res => res.data).catch(rej => rej)
	}

	static async salvarFotoProtocolo(dados, body) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/salvarFotoProtocolo",
			method: "POST",
			metodo: "POST",
			data: body,
			cabecalho: {
				token: dados.token
			}
		}).then(res => res.data).catch(rej => rej)
	}

	static async informarProxEntrega(dados, body) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/informarProximaEntrega",
			method: "PUT",
			metodo: "PUT",
			data: body,
			cabecalho: {
				token: dados.token
			}
		})
	}

	static async acertar(dados, idServico) {
		return await API.post("/appProfissional/accessOutside", {
			dominio: dados.dominio,
			method: 'POST',
			metodo: 'POST',
			url: `https://${dados.dominio}/mobile/v50/informarAcertou.php`,
			data: {
				tokenAut: dados.token,
				idServico: idServico,
				idProf: dados.idProf,
				idMotoboy: dados.idProf
			},
			headers: {
				"justify-Type": "application/json"
			},
		}).then(res => res.data).catch(rej => rej)
	}

	static async cancelarServicoAcerto(dados, idServico, opt) {
		return await API.post("/appProfissional/accessOutside", {
			dominio: dados.dominio,
			method: 'POST',
			metodo: 'POST',
			url: `https://${dados.dominio}/mobile/v50/recebeCancelamentoApp.php`,
			data: {
				tokenAut: dados.token,
				idServico: idServico,
				idProf: dados.idProf,
				idMotoboy: dados.idProf,
				opCancelamento: opt,
				txtCancelamento: opt == "RS"
					? "Reabrir o serviço para outros fazerem"
					: opt == "CS"
						? "Cancelar de vez o serviço"
						: "Deixar o serviço sem profissional",
				alertaPainel: "S"
			},
			headers: {
				"justify-Type": "application/json"
			},
		}).then(res => res.data).catch(rej => rej)
	}

	static confirmarColeta = async (dados, data) => API.post("/appProfissional/acessar", {
		dominio: dados.dominio,
		method: 'POST',
		metodo: 'POST',
		rota: "/confirmarColeta",
		data: data,
		cabecalho: { token: dados.token }
	}).then(res => res.data).catch(rej => rej)

	static limparEndereco = async (dados, data) => API.post("/appProfissional/acessar", {
		dominio: dados.dominio,
		method: 'PUT',
		metodo: 'PUT',
		rota: "/limparEndereco",
		data: data,
		cabecalho: { token: dados.token }
	}).then(res => res.data).catch(rej => rej)

	static informarCodigo = async (uri, metodo, dados, data) => API.post("/appProfissional/acessar", {
		dominio: dados.dominio,
		method: metodo,
		metodo: metodo,
		rota: uri,
		data: data,
		cabecalho: { token: dados.token }
	}).then(res => res.data).catch(rej => rej)

	/** Gestão de vagas — módulo ativo (MD md_g_vagas). geo: { latitude, longitude } */
	static async gestaoVagasModuloAtivo(dados, geo = null) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasModuloAtivo",
			params: {
				idProf: dados.idProf,
				dominio: dados.dominio,
				...(geo?.latitude != null && geo?.longitude != null
					? { la: geo.latitude, lo: geo.longitude }
					: {}),
			},
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Gestão de vagas — prioridade de ingresso (titular) no dia atual. */
	static async gestaoVagasPrioridadeIngressoHoje(dados, geo = null) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasPrioridadeIngressoHoje",
			params: {
				idProf: dados.idProf,
				dominio: dados.dominio,
				...(geo?.latitude != null && geo?.longitude != null
					? { la: geo.latitude, lo: geo.longitude }
					: {}),
			},
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/**
	 * Hub unificado — perto / minhas / fila + textosUx (mobileNovo1 gestaoVagasHubApp).
	 * @param {{ entrada?: 'menu'|'fab', aba?: string, incluirPrioridade?: boolean }} opcoes
	 */
	static async gestaoVagasHubApp(dados, geo = null, opcoes = {}) {
		const entrada = opcoes.entrada === "fab" ? "fab" : "menu"
		const params = {
			idProf: dados.idProf,
			dominio: dados.dominio,
			entrada,
			...(opcoes.aba ? { aba: String(opcoes.aba) } : {}),
			...(opcoes.incluirPrioridade === false ? { incluirPrioridade: "0" } : {}),
			...(opcoes.incluirPrioridade === true ? { incluirPrioridade: "1" } : {}),
			...(geo?.latitude != null && geo?.longitude != null
				? { la: geo.latitude, lo: geo.longitude }
				: {}),
		}
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasHubApp",
			params,
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token },
		})
			.then((res) => res.data)
			.catch((rej) => rej)
	}

	/** Gestão de vagas — listagem e mensagem (1 vaga traz mensagem completa). */
	static async gestaoVagasListarApp(dados, geo = null) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasListarApp",
			params: {
				idProf: dados.idProf,
				dominio: dados.dominio,
				...(geo?.latitude != null && geo?.longitude != null
					? { la: geo.latitude, lo: geo.longitude }
					: {}),
			},
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Gestão de vagas — detalhe/mensagem de uma vaga. */
	static async gestaoVagasDetalheApp(dados, idVaga, geo = null) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasDetalheApp",
			params: {
				idProf: dados.idProf,
				dominio: dados.dominio,
				idVaga,
				...(geo?.latitude != null && geo?.longitude != null
					? { la: geo.latitude, lo: geo.longitude }
					: {}),
			},
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Gestão de vagas — ingressar em um dia civil (data: AAAA-MM-DD). */
	static async gestaoVagasIngressarApp(dados, idVaga, data, geo = null) {
		const idVagaNum = parseInt(idVaga, 10) || 0
		const payload = {
			idProf: dados.idProf,
			dominio: dados.dominio,
			idVaga: idVagaNum,
			data: String(data || "").trim(),
			...(geo?.latitude != null && geo?.longitude != null
				? { la: geo.latitude, lo: geo.longitude }
				: {}),
		}
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasIngressarApp",
			method: "POST",
			metodo: "POST",
			params: payload,
			data: payload,
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Gestão de vagas — atualizar dias do titular ativo. */
	static async gestaoVagasIconeFilaApp(dados) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasIconeFilaApp",
			params: {
				idProf: dados.idProf,
				dominio: dados.dominio,
			},
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	static async gestaoVagasFilaApp(dados, geo = null) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasFilaApp",
			params: {
				idProf: dados.idProf,
				dominio: dados.dominio,
				...(geo?.latitude != null && geo?.longitude != null
					? { la: geo.latitude, lo: geo.longitude }
					: {}),
			},
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	static async gestaoVagasEntrarFilaApp(dados, idVaga, geo = null) {
		const idVagaNum = parseInt(idVaga, 10) || 0
		const payload = {
			idProf: dados.idProf,
			dominio: dados.dominio,
			idVaga: idVagaNum,
			...(geo?.latitude != null && geo?.longitude != null
				? { la: geo.latitude, lo: geo.longitude }
				: {}),
		}
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasEntrarFilaApp",
			method: "POST",
			metodo: "POST",
			params: payload,
			data: payload,
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	static async gestaoVagasSairFilaApp(dados, idVaga) {
		const idVagaNum = parseInt(idVaga, 10) || 0
		const payload = {
			idProf: dados.idProf,
			dominio: dados.dominio,
			idVaga: idVagaNum,
		}
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasSairFilaApp",
			method: "POST",
			metodo: "POST",
			params: payload,
			data: payload,
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	static async gestaoVagasAtualizarTitularApp(dados, idVaga, dias) {
		const idVagaNum = parseInt(idVaga, 10) || 0
		const payload = {
			idProf: dados.idProf,
			dominio: dados.dominio,
			idVaga: idVagaNum,
			dias
		}
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasAtualizarTitularApp",
			method: "PUT",
			metodo: "PUT",
			params: payload,
			data: payload,
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Gestão de vagas — sair da titularidade de um dia (diaId: seg|ter|qua|qui|sex|sab|dom). */
	static async gestaoVagasSairTitularApp(dados, idVaga, diaId) {
		const idVagaNum = parseInt(idVaga, 10) || 0
		const payload = {
			idProf: dados.idProf,
			dominio: dados.dominio,
			idVaga: idVagaNum,
			diaId: String(diaId || "").trim().toLowerCase(),
		}
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasSairTitularApp",
			method: "POST",
			metodo: "POST",
			params: payload,
			data: payload,
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Gestão de vagas — confirmar presença (resposta ao lembrete de confirmação). */
	static async gestaoVagasConfirmarPresencaApp(dados, idVaga, idTitular = null, tipoLembrete = null) {
		const idVagaNum = parseInt(idVaga, 10) || 0
		const payload = {
			idProf: dados.idProf,
			idMotoboy: dados.idProf,
			dominio: dados.dominio,
			idVaga: idVagaNum,
			dataRef: new Date().toISOString().slice(0, 10),
			...(idTitular ? { idTitular: parseInt(idTitular, 10) } : {}),
			...(tipoLembrete ? { tipoLembrete: String(tipoLembrete) } : {}),
		}
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasConfirmarPresencaApp",
			method: "POST",
			metodo: "POST",
			params: payload,
			data: payload,
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Gestão de vagas — recusar presença (resposta ao lembrete de confirmação). Remove o profissional da vaga. */
	static async gestaoVagasRecusarPresencaApp(dados, idVaga, idTitular = null, tipoLembrete = null) {
		const idVagaNum = parseInt(idVaga, 10) || 0
		const payload = {
			idProf: dados.idProf,
			idMotoboy: dados.idProf,
			dominio: dados.dominio,
			idVaga: idVagaNum,
			dataRef: new Date().toISOString().slice(0, 10),
			...(idTitular ? { idTitular: parseInt(idTitular, 10) } : {}),
			...(tipoLembrete ? { tipoLembrete: String(tipoLembrete) } : {}),
		}
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/gestaoVagasRecusarPresencaApp",
			method: "POST",
			metodo: "POST",
			params: payload,
			data: payload,
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Módulo quilometragem rodada (mobileNovo1 rotas serviço) */
	static async kmJornadaConfig(dados, extraParams = {}) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/kmJornadaConfig",
			params: { idProf: dados.idProf, ...extraParams },
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	static async kmJornadaAtual(dados) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/kmJornadaAtual",
			params: { idProf: dados.idProf },
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	static async kmJornadaIniciar(dados, body) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/kmJornadaIniciar",
			method: "POST",
			metodo: "POST",
			data: { idProf: dados.idProf, ...body },
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Leitura de KM na foto do hodômetro (OpenAI Vision; URL HTTPS do CDN). */
	static async kmJornadaLerOdometro(dados, body) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/kmJornadaLerOdometro",
			method: "POST",
			metodo: "POST",
			data: { idProf: dados.idProf, ...body },
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	static async kmJornadaFinalizar(dados, body) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/kmJornadaFinalizar",
			method: "PUT",
			metodo: "PUT",
			data: { idProf: dados.idProf, ...body },
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	static async kmJornadaResponderCorrecao(dados, body) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/kmJornadaResponderCorrecao",
			method: "PUT",
			metodo: "PUT",
			data: { idProf: dados.idProf, ...body },
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	static async kmJornadaRelatorioFinanceiro(dados, params = {}) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/kmJornadaRelatorioFinanceiro",
			params: { idProf: dados.idProf, ...params },
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Financeiro do profissional: pendentes (sem acerto) + fechamentos realizados. */
	static async kmFinanceiroProfissional(dados, params = {}) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/kmFinanceiroProfissional",
			params: { idProf: dados.idProf, ...params },
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Últimas jornadas (somente dados operacionais; sem valores financeiros). */
	static async kmJornadaRecentes(dados, params = {}) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/kmJornadaRecentes",
			params: { idProf: dados.idProf, limite: 30, ...params },
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Campanhas e bonificações visíveis ao profissional (progresso + status). */
	static async campanhasBonificacaoApp(dados) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/campanhasBonificacaoApp",
			params: {
				idProf: dados.idProf,
				dominio: dados.dominio,
			},
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Indica se há campanha vigente e elegível para exibir o item no menu. */
	static async campanhasBonificacaoModuloAtivo(dados) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/campanhasBonificacaoApp",
			params: {
				idProf: dados.idProf,
				dominio: dados.dominio,
				apenasDisponibilidade: 1,
			},
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}

	/** Histórico de pagamentos de bônus de campanha (filtro por período). */
	static async campanhasBonificacaoPagamentosApp(dados, { dataInicio = "", dataFim = "" } = {}) {
		return await API.post("/appProfissional/acessar", {
			dominio: dados.dominio,
			rota: "/campanhasBonificacaoPagamentosApp",
			params: {
				idProf: dados.idProf,
				dominio: dados.dominio,
				dataInicio,
				dataFim,
			},
			method: "GET",
			metodo: "GET",
			cabecalho: { token: dados.token }
		}).then(res => res.data).catch(rej => rej)
	}
}

export default ServicoAPI